import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class CodesRepairRoute extends AuthenticatedRoute {}
